import { Box, Typography } from "@mui/material"
import { TargetEditor } from "routes/schedule/compare/target-editor"
import { ListItemBox } from "lib/@components/ListItemBox"

export function DifferenceTitle({ label }) {
    return (
        <ListItemBox>
            <Box flex={1}>
                <TargetEditor>
                    <Typography sx={{ ml: 1, textTransform: "capitalize" }} variant="subtitle2">
                        {label}
                    </Typography>
                </TargetEditor>
            </Box>

            <Box flex={1} />
        </ListItemBox>
    )
}
